/**
 * Compares string with 'true'
 * @param value boolean or string to parse
 * @returns boolean
 */
export function parseBool(value) {
  return typeof value === 'boolean' ? value : value == 'true';
}

/**
 * {@link JSON.parse} returning fallback instead of throwing on corrupted input
 * @param text JSON string
 * @param fallback returned when text is empty or not valid JSON
 * @returns parsed value or fallback
 */
export function parseJSON<T>(text: string, fallback: T = null): T {
  if (!text) return fallback;
  try {
    return JSON.parse(text) as T;
  } catch (reason) {
    console.error('Failed to parse JSON!', reason, text);
    return fallback;
  }
}

/**
   * Returns array filter with provided equals comparison
   * @param equals
   * @returns
   */
export function uniqueArrayFilterFce<T>(equals: (a: T, b: T) => boolean) {
  return (value: T, index: number, array: T[]) => array.findIndex(val => equals(value, val)) === index;
}

export function diffObjects(obj1: any, obj2: any, path = '') {
  let changes: any = [];

  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    if (obj1 !== obj2) {
      changes.push({ path, from: obj1, to: obj2 });
    }
    return changes;
  }

  const allKeys = new Set([...Object.keys(obj1), ...Object.keys(obj2)]);
  for (let key of allKeys) {
    const newPath = path ? `${path}.${key}` : key;
    changes = changes.concat(diffObjects(obj1[key], obj2[key], newPath));
  }

  return changes;
}